
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { X } from 'lucide-react';
import type { Application } from '@/types/database.types';
import type { UseFormRegister } from 'react-hook-form';

interface AdditionalContactFormProps {
  index: number;
  register: UseFormRegister<Partial<Application>>;
  onRemove: () => void;
  onBlur: (e: React.FocusEvent<HTMLInputElement>) => void;
}

export const AdditionalContactForm = ({ 
  index, 
  register, 
  onRemove,
  onBlur
}: AdditionalContactFormProps) => {
  return (
    <Card>
      <CardContent className="pt-6">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-lg font-medium">Additional Contact {index + 1}</h3>
          <Button variant="ghost" size="sm" onClick={onRemove}>
            <X className="h-4 w-4 text-muted-foreground" />
          </Button>
        </div>
      
        <div className="space-y-4">
          <div className="grid gap-6 md:grid-cols-2">
            <div className="space-y-2">
              <Label htmlFor={`additional_contacts.${index}.first_name`}>First Name</Label>
              <Input
                id={`additional_contacts.${index}.first_name`}
                {...register(`additional_contacts.${index}.first_name` as const)}
                placeholder="First name"
                onBlur={onBlur}
              />
            </div>
            
            <div className="space-y-2">
              <Label htmlFor={`additional_contacts.${index}.last_name`}>Last Name</Label>
              <Input
                id={`additional_contacts.${index}.last_name`}
                {...register(`additional_contacts.${index}.last_name` as const)}
                placeholder="Last name"
                onBlur={onBlur}
              />
            </div>
          </div>
          
          <div className="space-y-2">
            <Label htmlFor={`additional_contacts.${index}.title`}>Role Title</Label>
            <Input
              id={`additional_contacts.${index}.title`}
              {...register(`additional_contacts.${index}.title` as const)}
              placeholder="Role title"
              onBlur={onBlur}
            />
          </div>
          
          <div className="grid gap-6 md:grid-cols-2">
            <div className="space-y-2">
              <Label htmlFor={`additional_contacts.${index}.phone`}>Phone Number</Label>
              <Input
                id={`additional_contacts.${index}.phone`}
                {...register(`additional_contacts.${index}.phone` as const)}
                placeholder="Phone number"
                type="tel"
                onBlur={onBlur}
              />
            </div>
            
            <div className="space-y-2">
              <Label htmlFor={`additional_contacts.${index}.email`}>Email Address</Label>
              <Input
                id={`additional_contacts.${index}.email`}
                {...register(`additional_contacts.${index}.email` as const)}
                placeholder="Email address"
                type="email"
                onBlur={onBlur}
              />
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
